import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import i18n from './locales/i18n'

Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

Vue.mixin({
  methods: {
    /**
     * Axios request wrapper
     *
     * @param method  POST|GET|PUT
     * @param uri     The URI after your config URL
     * @param data    The data you want to send to the API
     */
    request(method, uri, data = {}) {
      return new Promise((resolve) => {
          axios({
            method,
            data,
            url: store.state.config.url + uri,
          })
              // On success resolve the promise
              .then((response) => resolve(response.data))
              // Global error handling
              .catch((error) => {
                console.error(error);
              });
      });
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
